import { MarkerBox } from "@opendaw/studio-boxes";
import { asInstanceOf, UUID } from "@opendaw/lib-std";
import { Facade, Props } from "../Common";
export class MarkerImpl extends Facade {
    static wrap(context, box) {
        return context.facade(box, () => new MarkerImpl(context, box));
    }
    constructor(context, box) {
        super(context, box);
        this.bind({ position: box.position, label: box.label, hue: box.hue, plays: box.plays });
    }
}
export var Markers;
(function (Markers) {
    Markers.list = (context, track) => track.markers.pointerHub.incoming()
        .map(({ box }) => MarkerImpl.wrap(context, asInstanceOf(box, MarkerBox)))
        .sort((a, b) => a.position - b.position);
    Markers.create = (context, track, props) => context.edit(() => {
        const count = track.markers.pointerHub.incoming().length;
        const box = MarkerBox.create(context.boxGraph, UUID.generate(), box => {
            box.label.setValue(`Marker ${count + 1}`);
            box.hue.setValue(190);
            box.track.refer(track.markers);
        });
        return Props.apply(MarkerImpl.wrap(context, box), props);
    });
})(Markers || (Markers = {}));
